import Vue from 'vue';
import Vuex from 'vuex';
import * as VueGoogleMaps from 'vue2-google-maps';
import moment from 'moment';
import oLocalStorage from '@/services/objectLocalStorage';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';

Vue.use(Vuex);

const appVersion = `${JSON.stringify(require('@/../package.json').version)
  .replace('"', '')
  .replace('"', '')}`;

const configFile = require(process.env.VUE_APP_CONFIG);
const config = configFile.config;

let citySelected =
  oLocalStorage.get(keys.citySelected) !== null
    ? oLocalStorage.get(keys.citySelected)
    : config.CITIES['BCN'];

let defaultLangSelected =
  oLocalStorage.get(keys.langSelected) !== null
    ? oLocalStorage.get(keys.langSelected)
    : citySelected.defaultLanguage;

if (defaultLangSelected) {
  moment.locale(defaultLangSelected.langIso);
}

let citiesArray = [];

_.each(config.CITIES, itCity => {
  citiesArray.push(itCity);
});

let dateFormat = moment()
  .localeData()
  .longDateFormat('L')
  .replace('YYYY', 'yyyy')
  .replace('DD', 'dd');

const state = {
  langs: config.LANGUAGES,
  activeSection: '',
  isLogged: !!oLocalStorage.get(keys.tokenKey),
  canBuyPack: true,
  canBuySubscription: true,
  user:
    oLocalStorage.get(keys.userDataKey) !== null
      ? oLocalStorage.get(keys.userDataKey)
      : null,
  countries: config.COUNTRIES,
  citiesArray: citiesArray,
  citySelected: citySelected,
  countrySelected: config.COUNTRIES[citySelected.country],
  langSelected: defaultLangSelected,
  token:
    oLocalStorage.get(keys.tokenKey) !== null
      ? oLocalStorage.get(keys.tokenKey)
      : null,
  dateFormat: dateFormat,
  dateFormatTime: `${dateFormat} 'HH:mm'`,
  headquarters: config.HEADQUARTERS,
  isShowingParkingAsList:
    oLocalStorage.get(keys.homeData) !== null
      ? oLocalStorage.get(keys.homeData).showAsList
      : false,
  parkingsNetwork: [],
  homeData:
    oLocalStorage.get(keys.homeData) !== null
      ? oLocalStorage.get(keys.homeData)
      : {},
  restoreHomeData: false,
  forgotUser: '',
  appVersion: appVersion,
  apiVersion: config.API_VERSION,
  apiPath: config.API_PATH,
  apiPathWithVersion: `${config.API_PATH}/${config.API_VERSION}`,
  goToRouteAfterLogin: null,
  lastRoute: null,
  balanceBeforeBuying:
    oLocalStorage.get(keys.balanceBeforeBuying) !== null
      ? oLocalStorage.get(keys.balanceBeforeBuying).balance
      : 0,
  awsUrl: config.AWS_URL,
  lastSelectedProduct:
    oLocalStorage.get(keys.lastSelectedProduct) !== null
      ? oLocalStorage.get(keys.lastSelectedProduct)
      : {},
  lastSubscription:
    oLocalStorage.get(keys.lastSubscription) !== null
      ? oLocalStorage.get(keys.lastSubscription)
      : {}
};

const mutations = {
  UPDATE_LAST_SUBSCRIPTION(state, params) {
    state.lastSubscription = params.lastSubscription;
    oLocalStorage.set(keys.lastSubscription, params.lastSubscription);
  },
  UPDATE_LAST_SELECTED_PRODUCT(state, params) {
    state.lastSelectedProduct = params.selectedProduct;
    oLocalStorage.set(keys.lastSelectedProduct, params.selectedProduct);
  },
  UPDATE_USER_DATA(state, params) {
    state.user.firstname = params.firstname;
    state.user.lastname = params.lastname;
    oLocalStorage.set(keys.userDataKey, state.user);
  },
  UPDATE_PARKINGS_NETWORK(state, params) {
    state.parkingsNetwork = params.parkings;
  },
  CHANGE_SHOWING_PARKING_AS_LIST(state, params) {
    state.isShowingParkingAsList = params.showAsList;
  },

  CHANGE_TITLE_SECTION(state, params) {
    state.activeSection = params.text;
  },

  UPDATE_USER(state, user) {
    state.isLogged = true;
    state.user = user;
    oLocalStorage.set(keys.userDataKey, user);
  },

  UPDATE_USERNAME(state, username) {
    state.user.username = username;
    // oLocalStorage.set(keys.userDataKey, user);
  },

  UPDATE_TOKEN(state, token) {
    token.expirationDate = moment()
      .add(token.expires_in, 'seconds')
      .toDate();
    state.token = token;
    oLocalStorage.set(keys.tokenKey, token);
  },

  LOGOUT_USER(state) {
    state.isLogged = false;
    state.user = null;
    state.token = null;
    oLocalStorage.remove(keys.tokenKey);
    oLocalStorage.remove(keys.userDataKey);
    oLocalStorage.remove(keys.oldUserDataKey);
    oLocalStorage.remove(keys.oldTokenKey);
  },

  CHANGE_LANG_SELECTED(state, item) {
    state.langSelected = state.langs[item.langSelected];
    oLocalStorage.set(keys.langSelected, state.langSelected);

    moment.locale(state.langSelected.langIso);

    state.dateFormat = moment()
      .localeData()
      .longDateFormat('L')
      .replace('YYYY', 'yyyy')
      .replace('DD', 'dd');
    state.dateFormatTime = `${state.dateFormat} HH:mm`;

    EventBus.$emit(keys.eventOnLanguageChanged);

    Vue.use(VueGoogleMaps, {
      load: {
        key: state.countrySelected.googleKey,
        libraries: 'places' // This is required if you use the Autocomplete plugin
        //   region: 'VI',
        // language: 'vi',
      }
    });
  },

  CITY_SELECTED(state, item) {
    state.citySelected = item.city;

    // let defaultLangSelected = oLocalStorage.get(keys.langSelected) !== null ? oLocalStorage.get(keys.langSelected) : citySelected.defaultLanguage;
    // if (defaultLangSelected == null) {
    //   defaultLangSelected = item.city.defaultLanguage;
    // }
    // oLocalStorage.set(keys.citySelected, state.citySelected);

    state.countrySelected = config.COUNTRIES[state.citySelected.country];

    // EventBus.$emit(keys.citySelected);

    // this.commit('CHANGE_LANG_SELECTED', {
    //   langSelected: defaultLangSelected.langIso
    // });
  },

  SAVE_HOME_DATA(state, item) {
    state.homeData = item.data;
    oLocalStorage.set(keys.homeData, _.clone(item.data));
  },

  SET_RESTORE_HOME_DATA(state, item) {
    state.restoreHomeData = item.data;
  },

  FORGOT_USER(state, item) {
    if (typeof item !== 'undefined') {
      state.forgotUser = item.username;
    } else {
      state.forgotUser = '';
    }
  },

  UPDATE_GO_TO_ROUTE_AFTER_LOGIN(state, params) {
    state.goToRouteAfterLogin = params.to;
  },

  UPDATE_LAST_ROUTE(state, params) {
    state.lastRoute = params.from;
  },

  UPDATE_BALANCE_BEFORE_BUYING(state, params) {
    state.balanceBeforeBuying = params.balanceBeforeBuying;
    oLocalStorage.set(keys.balanceBeforeBuying, {
      balance: state.balanceBeforeBuying
    });
  }
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  keys,
  mutations
});
